import { Image } from '@chakra-ui/react';
import ImpactReporth2 from '../../../../../components/sections/impactreport/impact-h2';

// Chart
import scorecardGradesImg from '../../../../../components/ui/corporateresponsibility/impact/2024-impact-report/appendices/appendix-d/appendix_d_cr_scorecard_grades.png';

export default function TwentyTwentyFourImpactReportAppendixD() {
    return (
        <section id='appendix-d-section'>
            <div className='container flow'>
                <ImpactReporth2>Appendix D: Corporate Responsibility Scorecard Rating System</ImpactReporth2>
                <p>
                    To assess the performance of our manufacturing partner facilities in terms of social responsibility, environmental sustainability, and product compliance, CSC has developed a rating system known as the Corporate Responsibility (CR) Scorecard Rating System. This system primarily evaluates Tier 1 manufacturing partner facilities. A comprehensive CR Scorecard Rating, or CR Grade, is determined only when grades are assigned for all three key areas: social responsibility, environmental sustainability, and product compliance. Each area carries equal weight in the total CR Grade calculation. In 2024, 139 Tier 1 manufacturing partner facilities received a CR Scorecard Grade.
                </p>
                <ul>
                    <li>
                        Social Responsibility Scorecard Rating System
                    </li>
                    <li>
                        Product Compliance Scorecard Rating System
                    </li>
                    <li>
                        Environmental Responsibility Scorecard Rating System
                    </li>
                </ul>

                <figure className='table-img scorecard-grades'>
                    <figcaption>
                        <p>2024 Tier 1 Manufacturing Partner CR Scorecard Grades</p>
                    </figcaption>
                    <Image src={scorecardGradesImg} alt='Scorecard grades' />
                </figure>

                {/* <div className='table-wrapper' tabindex="0" role="region" aria-labelledby="tableCaption_09" style={{ background: 'none'}}>
                    <table className='reduced-font-table' style={{ tableLayout: 'auto', width: '100%' }}>
                        <caption id="tableCaption_09">2024 Tier 1 Manufacturing Partner CR Scorecard Grades</caption>
                        <thead>
                            <tr>
                            <th scope="col">Grade</th>
                            <th scope="col">2021</th>
                            <th scope="col">2022</th>
                            <th scope="col">2023</th>
                            <th scope="col">2024</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                            <th scope='row'>A</th>
                            <td>17%</td>
                            <td>21%</td>
                            <td>28%</td>
                            <td>30%</td>
                            </tr>
                            <tr>
                            <th scope='row'>B</th>
                            <td>51%</td>
                            <td>47%</td>
                            <td>51%</td>
                            <td>47%</td>
                            </tr>
                            <tr>
                            <th scope='row'>C</th>
                            <td>32%</td>
                            <td>32%</td>
                            <td>21%</td>
                            <td>23%</td>
                            </tr>
                        </tbody>
                    </table>
                </div> */}
            </div>
        </section>
    );
}